export const PINK_ANGLE_COLORS = [0xFC99C4, 0xF94F6F];
export const CENTER_OF_CIRCLE = { x: 600, y: 310 };
export const CIRCLE_RADIUS = 200;
export const INITIAL_RADIANS = [Math.PI, -Math.PI / 2, 0];
export const ARC_COLOR_ARR = [0x000000, 0x000000, 0xFFBD06];
export const SLIDERS_COORD = [{ x: 400, y: 800 }, { x: 760, y: 800 },{ x: 1120, y: 800 }];
export const SLIDERS_COORD_OFFSET_VERTICAL = [{ x: 60, y: 420 }, { x: -280, y: 620 },{ x: 60, y: 620 }];
export const INFO_SLIDER_COORD = { x: 1180, y: 200 };
export const RANDOM_BUTTON_COORD = { x: 200, y: 800 };
export const INFO_SLIDER_ASSETS_SLUG = "circle-theorem-5";